import { apiGetAuth } from '@/utils/api'
import { API_MENU } from '@/utils/api-url'
import {
  notificationDanger
} from '@/utils/notification'

const state = {
  list_all_menu: {
    isLoading: false,
    data: false
  },
  list_menu_by_token: {}
}

const mutations = {
  "SET_ALL_MENU": (state, payload) => {
    state.list_all_menu = payload
  },
  "SET_MENU_LIST_BY_TOKEN": (state, payload) => {
    state.list_menu_by_token = payload
  }
}

const actions = {
  async getListAllMenu(context, payload) {
    try {
      context.commit('SET_ALL_MENU', {isLoading: true})
      const response = await apiGetAuth(API_MENU.GET_ALL_MENU, payload)
      context.commit('SET_ALL_MENU', {
        isLoading: false,
        data: response.data
      })
    } catch (err) {
      context.commit('SET_ALL_MENU', {
        isLoading: false,
        data: false
      })
      notificationDanger(err)
    }
  },
  async getMenuListByToken(context, payload) {
    try {
      const response = await apiGetAuth(API_MENU.LIST_BY_TOKEN, payload)
      context.commit('SET_MENU_LIST_BY_TOKEN', response.data)
    } catch (err) {
      notificationDanger(err)
    }
  }
}

const getters = {
  get_all_menu: state => {
    return state.list_all_menu
  },
  get_menu_list_by_token: state => {
    return state.list_menu_by_token
  }
}

const namespaced = true
export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}

